import { render, staticRenderFns } from "./hotel-facility-list.vue?vue&type=template&id=b33bc734"
import script from "./hotel-facility-list.vue?vue&type=script&lang=ts"
export * from "./hotel-facility-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports